import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from "../services/auth.service";
import {NgClass, NgIf, AsyncPipe} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {MatListModule} from '@angular/material/list';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        AsyncPipe,
        RouterLink,
        RouterLinkActive,
        MatListModule
    ]
})
export class NavigationComponent implements OnInit {

  @Input()
  horizontal: boolean;

  constructor(
    public auth: AuthService
  ) { }

  ngOnInit(): void {
  }

}
